import {createStore} from 'vuex'
import cookie from '@/utils/cookie'

export default createStore({
  state: {
    admin: cookie.get('admin') ? JSON.parse(cookie.get('admin')) : {account: '', mobile: ''},
    token: cookie.get('token') || '',
    messageAlert: false,
    permissionPoints: <any>[],
    pagePermissionPoints: <any>[],
    currentPage: 1
  },
  getters: {
    admin: state => state.admin,
    token: state => state.token,
    messageAlert: state => state.messageAlert,
    permissionPoints: state => state.permissionPoints,
    pagePermissionPoints: state => state.pagePermissionPoints,
    currentPage: state => state.currentPage
  },
  mutations: {
    setAdmin: (state, value: any) => {
      state.admin = value
    },
    setToken: (state, value: any) => state.token = value,
    setMessageAlert: (state, value: boolean) => {
      state.messageAlert = value
    },
    setPermissionPoints: (state, value: Array<any>) => {
      state.permissionPoints = value
    },
    setPagePermissionPoints: (state, value: Array<string>) => {
      state.pagePermissionPoints = value
    },
    setCurrentPage: (state, value: number) => {
      state.currentPage = value
    }
  },
  actions: {
    setAdmin: (state, value: any) => {
      state.commit('setAdmin', value)
    },
    setToken: (state, value: any) => {
      state.commit('setToken', value)
    },
    setMessageAlert: (state, value: boolean) => {
      state.commit('setMessageAlert', value)
    },
    setPermissionPoints: (state, value: Array<any>) => {
      state.commit('setPermissionPoints', value)
    },
    setPagePermissionPoints: (state, value: Array<string>) => {
      state.commit('setPagePermissionPoints', value)
    },
    setCurrentPage: (state, value: number) => {
      state.commit('setCurrentPage', value)
    }
  },
  modules: {}
})
